import {isNotNil} from 'ramda';

import type {FinancialProductType} from '../schemas/FinancialProductTypeSchema';
import {getFinancialProductOffer} from './getFinancialProductOffer';

export const getConfiguredFinancialProducts = (
  products: Parameters<typeof getFinancialProductOffer>[0],
  productOrder: readonly FinancialProductType[]
) =>
  productOrder.filter((productType) => isNotNil(getFinancialProductOffer(products, productType)));
